import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/about/AboutContent.jsx");
